import { PlotGroup } from "./models/PlotGroup";
import { AbacoVuexModule, State } from "@abaco/web-common/src/app";
import { Editability, PlotWell } from "./models/Plot";
import { CropFilter } from "./models/CropFilter";
import { Block } from "./models/Block";
import { PlotSeed } from "./models/Seed";
import { Plot } from "@abaco/portal-global-state/src/modules/global-state/models/Plot";
import { TriggerPlotSelection } from "./models/Plot";
import { ChartVariety } from "./models/Chart";
import { ChartCrop } from "./models/Chart";
import { Crop } from "./models/Crop";

export default class CropPlanVuexModule extends AbacoVuexModule {
    @State() curBlock!: Block | null;
    @State() curBlockChild!: Block | null;
    @State() curPlotGroup!: PlotGroup | null;
    @State() curCropFilter!: CropFilter | null;
    @State() curVariety!: PlotSeed | null;
    @State() curCrop!: Crop | null;
    @State({ default: [] }) curPlotsInGroup!: Plot[];
    @State({ default: [] }) curPlotsNotInGroup!: Plot[];
    @State({ default: [] }) selectedPlotsToRemove!: Plot[];
    @State({ default: [] }) selectedPlotsToAdd!: Plot[];
    @State({ default: false }) inPlotGroupDetail!: boolean;
    @State({ default: { component: "", number: 0 } }) triggerPlotSelection!: TriggerPlotSelection;
    @State({ default: [] }) allPlotsSelected!: Plot[];
    @State({ default: [] }) blocks!: Block[];
    @State({ default: [] }) blockHistory!: Block[];
    @State() editability!: Editability | null;
    @State() drawnWkt!: string | null;
    @State() newPlot!: Plot | null;
    @State() newBlock!: Block | null;
    @State() canEditBlock!: boolean;
    @State() canViewBlock!: boolean;
    @State() canWorkOnVegCycle!: boolean;
    @State() canViewPhenology!: boolean;
    @State() canEditPhenology!: boolean;
    @State() canAddPlot!: boolean;
    @State() canMakeDigitalization!: boolean;
    @State() canEditRotationGeom!: boolean;
    @State() canAddRotation!: boolean;
    @State() canPrintQrCodes!: boolean;
    @State() canEditValidityDates!: boolean;
    @State() canUseAiFunc!: boolean;
    @State() canViewCropHistory!: boolean;
    @State() canEditCropHistory!: boolean;
    @State() showFullPlant!: boolean;
    @State({ default: -1 }) curRotation!: number;
    @State() maxBlockLevel!: number;
    @State() hideRotations!: boolean;
    @State({ default: false }) showCadastreLayer!: boolean;
    @State({ default: 0 }) refreshPlotMapComponentLayers!: number;
    @State({ default: false }) plotHasValidityDate!: boolean;
    @State() curChartVariety!: ChartVariety;
    @State() mapCanvas!: string | null;
    @State() triggerPrint!: number;
    @State() curChartCrop!: ChartCrop;
    @State() canImportPlot!: boolean;
    @State() canImportPlotBySubject!: boolean;
    @State() curTileButtonHighlighted!: string;
    @State({ default: true }) localFirstLogin!: boolean;
    @State() canViewLinkedParcel!: boolean;
    @State() canEditLinkedParcel!: boolean;
    @State() treeEstimatesWkt!: string;
    @State() minDistanceWell!: PlotWell | null;
    @State() backToModule!: string | null;
    @State({ default: [] }) currentMapHistory!: string[];
    @State({ default: 0 }) mapLoaded!: number;
    @State() viewThemeCompetence!: boolean;
    @State() updateThemeCompetence!: boolean;
    @State() createThemeCompetence!: boolean;
    @State() excludeGeogledianRegistrationCompetence!: boolean;
    @State() editGeogledianDatesCompetence!: boolean;
    @State() rotationParallel!: boolean;
    @State() isPlotEditing!: boolean;
    @State({ default: false }) plotGroupEditAuth!: boolean;
    @State() curThemeRange!: Range | null;
    @State({ default: null }) gMapCenter!: { lat: number; lng: number } | null;
    @State({ default: null }) gMapZoom!: number | null;
    @State() isAssociatedColdiretti!: boolean;
    @State({ default: false }) isColdiretti!: boolean;
    @State({ default: false }) lastPcgValidation!: string;
}
